(function () {
  const selector = '[data-saway-service-carousel]';

  function initCarousel(root) {
    if (!root || root.dataset.sawayServiceReady === 'true') return;

    root.dataset.sawayServiceReady = 'true';

    const slides = Array.from(root.querySelectorAll('[data-service-slide]'));
    const tabs = Array.from(root.querySelectorAll('[data-service-tab]'));
    const previous = root.querySelector('[data-service-direction="previous"]');
    const next = root.querySelector('[data-service-direction="next"]');
    const shouldAutoplay = root.dataset.autoplay === 'true';
    const interval = Number.parseInt(root.dataset.interval, 10) || 4500;
    let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
    let timer = null;

    function showSlide(index) {
      if (!slides.length) return;

      activeIndex = (index + slides.length) % slides.length;

      slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === activeIndex;
        slide.classList.toggle('is-active', isActive);
        slide.hidden = !isActive;
      });

      tabs.forEach((tab, tabIndex) => {
        const isActive = tabIndex === activeIndex;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
      });
    }

    function stop() {
      if (!timer) return;
      window.clearInterval(timer);
      timer = null;
    }

    function start() {
      if (!shouldAutoplay || slides.length < 2) return;
      stop();
      timer = window.setInterval(() => showSlide(activeIndex + 1), interval);
    }

    if (previous) {
      previous.addEventListener('click', () => {
        showSlide(activeIndex - 1);
        start();
      });
    }

    if (next) {
      next.addEventListener('click', () => {
        showSlide(activeIndex + 1);
        start();
      });
    }

    tabs.forEach((tab, tabIndex) => {
      tab.addEventListener('click', () => {
        showSlide(tabIndex);
        start();
      });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    showSlide(activeIndex);
    start();
  }

  function initAll(container) {
    container.querySelectorAll(selector).forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
